export default __webpack_public_path__ + "static/media/apple_logo.aa8a4ce7.png";